var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPhone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "carbon:phone-filled"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M12.3339 12.9497L13.5395 11.7437C13.7018 11.5833 13.9073 11.4734 14.1308 11.4276C14.3544 11.3817 14.5864 11.4017 14.7988 11.4853L16.2681 12.0721C16.4827 12.1593 16.6667 12.308 16.797 12.4997C16.9272 12.6913 16.9979 12.9172 17 13.1489V15.8409C16.9988 15.9986 16.9656 16.1543 16.9026 16.2988C16.8396 16.4433 16.748 16.5735 16.6334 16.6817C16.5188 16.7898 16.3834 16.8737 16.2355 16.9281C16.0877 16.9825 15.9303 17.0065 15.7729 16.9985C5.47744 16.3578 3.40004 7.63567 3.00717 4.29757C2.98893 4.13365 3.00559 3.96772 3.05606 3.8107C3.10653 3.65368 3.18966 3.50913 3.29998 3.38656C3.4103 3.26399 3.54531 3.16618 3.69613 3.09955C3.84695 3.03293 4.01016 2.99901 4.17503 3.00002H6.77447C7.00643 3.00071 7.23288 3.0708 7.4247 3.20129C7.61652 3.33178 7.76493 3.51669 7.85084 3.73225L8.43746 5.20209C8.52371 5.41372 8.54571 5.64608 8.50073 5.87015C8.45574 6.09421 8.34576 6.30005 8.18452 6.46195L6.97898 7.66797C6.97898 7.66797 7.67324 12.3682 12.3339 12.9497Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.b97b31ce62891ed549937b26d5a226dc.svg";
export { ForwardRef as ReactComponent };